//=====================================================
//　G003カレンダー月Body
//=====================================================
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Weather, StatusClass } from "../../utils/ConstCommon";
import { CtxG003 } from "./G003"

interface IFProps{
    apiData: any
}
export function G003CalendarMonthlyBody(props: IFProps){

    const history = useHistory();
    const ctx = useContext(CtxG003);

    //APIデータがない場合は処理無し
    if (!props.apiData) {
        return null;
    }

    //APIデータ整形
    //7日ごとに区切られた35日または42日分のデータ
    const monthlyBodys:IFMonthlyBodys[] = getMonthlyBodys(props.apiData, ctx.cDate);
    
    //日付押下時の処理
    function clickCell(val: IFMonthlyDay){
        //非活性セルの場合は処理中断
        if (getCellClass(val).indexOf("is-inactive") > -1){
            return false;
        }
        //日付を設定し週カレンダーへ遷移
        let tmpDate = new Date(ctx.cDate.getFullYear() + "/" + (ctx.cDate.getMonth() + 1) + "/" + val.day);
        ctx.setCDate(tmpDate);
        ctx.setCMonth(tmpDate);
        ctx.setMoveflg(true);
        history.push("/reservation/date/weekly");
    }

    return (
        
        <tbody>
            {monthlyBodys.map(function(rowVal, rowIdx){
                return (    
                    <tr key={rowIdx} className={rowVal.hasWeather ? "is-show-weather" : ""}>
                        {rowVal.data.map(function(colVal, colIdx){
                            return (
                                <td key={colIdx} className={getCellClass(colVal)} onClick={function(){clickCell(colVal)}}>
                                    <div className="calendar-date">
                                        <span className="calendar-date-day">{colVal.day}</span>
                                        {colVal.weather &&
                                            <span className={"calendar-date-weather " + Weather[colVal.weather]}></span>
                                        }
                                    </div>
                                    <div className="calendar-status">
                                        {(typeof(colVal.statusAm)==="number" && !colVal.closed) && <div className={"calendar-status-am " + StatusClass[colVal.statusAm]}></div>}
                                        {(typeof(colVal.statusPm)==="number" && !colVal.closed) && <div className={"calendar-status-pm " + StatusClass[colVal.statusPm]}></div>}
                                    </div>
                                </td>
                            )
                        })}
                    </tr>
                )
            })}
        </tbody>

    )

}

//-----------------------------------------------------
//　APIデータ整形
//-----------------------------------------------------
interface IFMonthlyBodys {
    hasWeather: boolean,
    data: IFMonthlyDay[]
}
interface IFMonthlyDay {
    currentMonth: boolean,
    closed: boolean,
    day: number,
    weather?: number,
    statusAm?: number,
    statusPm?: number,
}
function getMonthlyBodys(apiData: any, cDate: Date):IFMonthlyBodys[]{

    let tmpMonthlyBodys:IFMonthlyBodys[] = [];
    let tmpAllDays:IFMonthlyDay[] = [];

    //１．すべての表示対象日付情報を取得する
    //-----------------------------------------------------
    //前月日付取得
    tmpAllDays = tmpAllDays.concat(getPrevDays(cDate));

    //当月データをAPIデータから取得
    apiData.frames.forEach(function(val:any){
        let tmpCurrentDays:IFMonthlyDay = val;
        tmpCurrentDays.currentMonth = true;
        tmpAllDays.push(tmpCurrentDays);
    });

    //翌月日付取得
    tmpAllDays = tmpAllDays.concat(getNextDays(cDate, tmpAllDays.length));

    //２．1行分（7日）ごとに区切って配列に格納する
    //-----------------------------------------------------
    let tmpWeek:IFMonthlyDay[] = [];
    tmpAllDays.forEach(function(val, idx){
        let hasWeather = false;
        //1週間内に天気を含む日がある場合はクラス調整のためフラグを立てる
        if (val.weather) {
            hasWeather = true;
        }
        //1週間ごとにデータを分割
        if ((idx + 1) % 7 === 0 || idx === tmpAllDays.length - 1) {
            tmpWeek.push(val);
            tmpMonthlyBodys.push({hasWeather: hasWeather, data: tmpWeek});
            hasWeather = false;
            tmpWeek = [];
        } else {
            tmpWeek.push(val);
        }
    });

    return tmpMonthlyBodys;

}

//-----------------------------------------------------
//　セルのクラス取得
//-----------------------------------------------------
function getCellClass(val: IFMonthlyDay){

    let retClass = "";

    //午前午後の予約が埋まっている場合　または
    //前後の月の日付の場合　または
    //休診日の場合　はinactiveにする
    if ((val.statusAm === StatusClass["is-no-vacant"] && val.statusPm === StatusClass["is-no-vacant"])
        || (val.statusAm === StatusClass["is-reserve-phone"] && val.statusPm === StatusClass["is-reserve-phone"])
        || !val.currentMonth
        || val.closed){
        retClass += "is-inactive";
    } else {
        retClass = "is-active";
    }

    //休診日の場合はclosedにする
    if (val.closed){
        retClass += " is-closed";
    }

    return retClass;

}

//-----------------------------------------------------
//　前月日付取得
//-----------------------------------------------------
function getPrevDays(currentDate: Date):IFMonthlyDay[]{

    //対象月の始まり曜日を調べる（0が日曜日なので0の場合は7で上書き。1→月～7→日）
    const firstday = new Date(currentDate.setDate(1));
    let firstdayweek = firstday.getDay();
    if (firstdayweek === 0){
        firstdayweek = 7;
    }

    //前の月の表示日数を計算して取得
    let prevMonthDays:IFMonthlyDay[] = [];
    for (let i = firstdayweek - 1; i > 0; i--){
        let tmpDay = new Date(firstday);
        tmpDay.setDate(tmpDay.getDate() - i);
        prevMonthDays.push({currentMonth: false,closed: false, day: tmpDay.getDate()});
    }

    return prevMonthDays;

}

//-----------------------------------------------------
//　翌月日付取得
//-----------------------------------------------------
function getNextDays(currentDate: Date, allDaysCnt: number):IFMonthlyDay[]{

    //対象月の終わり曜日を調べる（0が日曜日なので0の場合は7で上書き。1→月～7→日）
    const lastday = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    let lastdayweek = lastday.getDay();
    if (lastdayweek === 0){
        lastdayweek = 7;
    }

    //次の月の表示日数を計算
    let nextMonthDaysCnt = 0;
    if (allDaysCnt > 35){
        //35日（5週）以上の場合、最終曜日から日曜日までの日付を取得
        nextMonthDaysCnt = 7 - lastdayweek;
    } else {
        //35日（5週）以内の場合
        nextMonthDaysCnt = 35 - allDaysCnt;
    }

    //次の月の表示日を取得
    let nextMonthDays:IFMonthlyDay[] = [];
    for (let i = 1; i <= nextMonthDaysCnt; i++){
        let tmpDay = new Date(lastday);
        tmpDay.setDate(tmpDay.getDate() + i);
        nextMonthDays.push({currentMonth: false, closed: false, day: tmpDay.getDate()});
    }

    return nextMonthDays;

}
